<template>
  <div class="ts-border ts-border-gray-300 ts-rounded-md ts-p-4 ts-space-y-2">
    <h6 class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md" style="width: fit-content">
      {{ $t('promotion.productItem') }}
    </h6>
    <ts-checkbox class="ts-font-light" v-model="model.is_all_product" @change="() => (model.product_list = [])">{{
      $t('promotion.applyForAllProduct') }}</ts-checkbox>
    <div class="table-ui-detail ts-overflow-auto ts-mt-2" style="height: 40vh;max-height: 40vh">
      <table class="ts-w-full ts-mt-4">
        <thead>
          <tr>
            <th width="2%" class="ts-text-center">
              {{ $t('no') }}
            </th>
            <th width="10%">
              {{ $t('productPriceSchema.productGroup') }}
            </th>
            <th width="10%">
              {{ $t('productPriceSchema.barcode') }}
            </th>
            <th width="15%">
              {{ $t('productPriceSchema.productNameEn') }}
            </th>
            <th width="15%">
              {{ $t('productPriceSchema.productNameKh') }}
            </th>
            <th width="8%">
              {{ $t('productPriceSchema.uom') }}
            </th>
            <th width="8%" class="text-center">
              {{ $t('productPriceSchema.unitPrice') }}
            </th>
            <th width="8%" class="text-center">
              {{ $t('productPriceSchema.incrementType') }}
            </th>
            <th width="8%" class="text-center">
              {{ $t('productPriceSchema.incrementAmount') }}
            </th>
            <th width="8%" class="text-center">
              {{ $t('productPriceSchema.maxPersons') }}
            </th>
            <th width="8%" class="text-center">
              {{ $t('productPriceSchema.serviceLength') }}
            </th>
            <th width="2%" class="ts-text-center">
              <a href="#" @click.prevent="addItem">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.product_list == 0">
            <td colspan="11" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
              <div class="validate ts-text-left" v-if="errors.has('po_detail')">
                {{ errors.first('po_detail') }}
              </div>
            </td>
          </tr>
          <tr class="ts-border-b " v-for="(item, index) in model.product_list" :key="index">
            <td class="ts-text-center">
              {{ index + 1 }}
            </td>
            <td class="ts-text-xs">
              {{ findProduct(item.product_id) ? findProduct(item.product_id).pro_group_name_en : '' }}
            </td>
            <td class="ts-text-xs">
              {{ findProduct(item.product_id) ? findProduct(item.product_id).barcode : '' }}
            </td>
            <td class="ts-text-xs">
              {{ findProduct(item.product_id) ? findProduct(item.product_id).product_name_en : '' }}
            </td>
            <td class="ts-text-xs">
              {{ findProduct(item.product_id) ?
                (findProduct(item.product_id).product_name_kh ?
                  findProduct(item.product_id).product_name_kh : 'N/A') : 'N/A' }}
            </td>
            <td style="width: 10%">
              <a-select v-model="item.uom_id" class="ts-w-full" style="min-width: 70px"
                :options="getUnitOfMeasures(item.uom_cat_id)" option-filter-prop="children" :class="{
                  'is-invalid': errors.has('po_detail.' + index + '.uom_id')
                }" @change="onUomChange(item)">
              </a-select>
              <div class="validate" v-if="errors.has('po_detail.' + index + '.uom_id')">
                {{ errors.first('po_detail.' + index + '.uom_id') }}
              </div>
            </td>
            <td class="ts-text-xs text-center">
              <ts-currency-input type="text" v-model="item.sale_price" currency="$"
                class="ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2 ts-h-8" disabled />
            </td>
            <td class="ts-text-xs text-center">
              <a-select v-model="item.increment_type" :options="incrementTypes" class="ts-w-full"
                :class="{ 'is-invalid': errors.has('increment_type') }" placeholder="Select"></a-select>
            </td>
            <td class="ts-text-xs text-center">
              <ts-currency-input type="text" v-model="item.increment_amount" currency="$"
                class="ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2 ts-h-8" />
            </td>
            <td class="ts-text-xs text-center">
              <input v-model="item.max_person" type="number" class="form-control" style="height: 32px;" />
            </td>
            <td class="ts-text-xs text-center">
              <input v-model="item.service_length" type="number" class="form-control" style="height: 32px;" />
            </td>
            <td class="ts-text-center">
              <a href="#" class="ts-text-red-700 hover:ts-text-red-700 text-center" @click.prevent="removeItem">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="validate ts-text-xs" v-if="errors.has('product_list')">
      {{ errors.first('product_list') }}
    </div>
    <a-modal v-if="show_form" v-model="show_form" :title="$t('promotion.product')" :footer="null" width="800px">
      <ProductList v-model="model" />
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'

export default {
  props: ['value', 'validate'],
  components: {
    ProductList
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('restaurantSale/productPriceSchema', ['formViewDatas']),
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
      }
      return []
    },
    unitOfMeasures() {
      if (this.formViewDatas['unitOfMeasures']) {
        return this.formViewDatas['unitOfMeasures'].map(el => ({
          value: el.uom_id,
          label: el.uom_name_en,
          uom_cat_id: el.uom_cat_id,
          is_default: el.is_default,
          stockout_quantity: el.stockout_quantity
        }))
      }
      return []
    },
    incrementTypes() {
      return [
        {
          value: '%',
          label: '%'
        },
        {
          value: this.$store.state.authUser.sys_setting.default_currency_sign,
          label: this.$store.state.authUser.sys_setting.default_currency_sign
        },
      ]
    },
  },
  methods: {
    findProduct(product_id) {
      return this.products.find(el => el.product_id == product_id)
    },
    addItem() {
      this.show_form = true
    },
    removeItem(index) {
      this.model.product_list.splice(index, 1)
    },
    getUnitOfMeasures(uom_cat_id) {
      return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
    },
    onUomChange(item) {
      const product = this.products.find(el => el.product_id == item.product_id)
      const price = product.sale_code.find(el => el.uom_id == item.uom_id)

      item.sale_price = price ? price.sale_price : 0
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>